import { range } from 'lodash'

import { StreamingTileLocalSliver } from 'types/streaming-tile-local-sliver'

import { getDefaultStreamingTileSliver } from './streamingTiles'

export const getDemoStreamingTiles = (n: number): StreamingTileLocalSliver[] =>
  range(n).map(() => getDefaultStreamingTileSliver())
